import React from "react";
import SelectLocationInput from "nlib/common/SelectLocationInput";

const SelectLocation = (props) => {
  const {
    value,
    onChange,
    ...restProps
  } = props;

  return (
    <SelectLocationInput
      value={value}
      invalid={!!(value?.name && !value?.id)}
      valid={!!(value?.name && value?.id)}
      onChange={onChange}
      {...restProps} />
  );
};

export default React.memo(SelectLocation);
